import React, { useEffect } from 'react'

const DynamicScriptLoader = () => {
  useEffect(() => {
    const scriptCookieCdn = document.createElement('script')
    const scriptOptanonWrapper = document.createElement('script')
    const commentNode = document.createComment(
      ' CookiePro Cookies Consent Notice end for unroll.me '
    )

    scriptCookieCdn.type = 'text/javascript'
    scriptCookieCdn.src =
      'https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js'
    scriptOptanonWrapper.type = 'text/javascript'
    scriptOptanonWrapper.textContent = 'function OptanonWrapper() {}'

    if (process.env.NODE_ENV === 'production') {
      scriptCookieCdn.setAttribute(
        'data-domain-script',
        '0195b4d6-3114-7b9d-a8b2-86b366a9c312'
      )
    } else {
      scriptCookieCdn.setAttribute(
        'data-domain-script',
        '0195b4d6-3114-7b9d-a8b2-86b366a9c312-test'
      )
    }

    scriptCookieCdn.async = true
    scriptOptanonWrapper.async = true

    document.head.appendChild(scriptCookieCdn)
    document.head.appendChild(scriptOptanonWrapper)
    document.head.appendChild(commentNode)

    return () => {
      document.head.removeChild(scriptCookieCdn)
      document.head.removeChild(scriptOptanonWrapper)
      document.head.removeChild(commentNode)
    }
  }, [])

  return null
}

export default DynamicScriptLoader
